import React, {useEffect, useState} from "react";
import Checkbox from "../../../components/Checkbox";
import DashboardPanel from "../../../components/DashboardPanel";
import {arePackagesWaitingForServerAck, filterPackagesWithOrderId, getPackageUID, withWarehousePackages} from "../../../lib/WarehouseHelper";
import OrderWithPackages from "./OrderWithPackages";
import Button from "../../../components/Button";
import {Set} from "immutable";
import PackedActions from "./actions/_4_PackedActions";


// In the pickup ready panel, packages are still grouped by order but partial
// orders are possible, so the package is the main unit here.
// Checkboxes are available to mark them as picked by the transporter.
const Panel = (props) => {
  const {
    warehouseId, packages,
    getJobById, getAlertInfoForJobId, getTagsForJobId,
  } = props;

  // Packages are grouped by jobId (for display purpose only)
  const [orders, setOrders] = useState({});

  useEffect(() => {
    setOrders(packages.reduce((acc, p) => {
      const jobId = p.get("jobId");

      if (!acc[jobId]) {
        // Init order info
        acc[jobId] = {
          ...getJobById(jobId),
          id: jobId, // keep in mind as the acc keys will be thrown away
          packages: [],
          alert: getAlertInfoForJobId(jobId),
          tags: getTagsForJobId(jobId),
        }
      }

      acc[jobId].packages.push(p);

      return acc;
    }, {}));
  }, [packages, getJobById, getAlertInfoForJobId, getTagsForJobId]);

  const [checkedIds, setCheckedIds] = useState(Set());
  const [ordersWithPackages, setOrdersWithPackages] = useState();

  useEffect(() => {
    const toggleOrderId = (jobId) => {
      const pids = filterPackagesWithOrderId(packages, jobId).map((p) => getPackageUID(p));
      let newSet = checkedIds;

      if (allPackagesAreChecked(pids)) {
        pids.forEach((pid) => newSet = newSet.delete(pid));
      } else {
        pids.forEach((pid) => newSet = newSet.add(pid));
      }

      setCheckedIds(newSet);
    }
    const allPackagesAreChecked = (pids) => pids.every((id) => checkedIds.has(id));
    const headerActionRenderer = (jobId, active) => (
      <Checkbox
        active={active}
        onClick={() => toggleOrderId(jobId)}
        checked={allPackagesAreChecked(filterPackagesWithOrderId(packages, jobId).map((p) => getPackageUID(p)))}
      />
    );
    const togglePackageId = (packageId) => {
      if (checkedIds.has(packageId)) {
        setCheckedIds(checkedIds.delete(packageId));
      } else {
        setCheckedIds(checkedIds.add(packageId));
      }
    }
    const packageActionRenderer = (packageUId, active) => {
      return (
        <Checkbox
          active={active}
          onClick={() => togglePackageId(packageUId)}
          checked={checkedIds.has(packageUId)}
        />
      );
    };

    // Update the orders with packages elem any time the orders or checked ids
    // change
    setOrdersWithPackages(Object.values(orders).map((o) => {
      const waiting = arePackagesWaitingForServerAck(o.packages);
      
      return <OrderWithPackages key={o.id} {...o}
        warehouseId={warehouseId}
        headerActionRenderer={headerActionRenderer}
        packageActionRenderer={packageActionRenderer}
        active={!waiting}
      />
    }));
  }, [orders, checkedIds]);

  const toggleAll = () => {
    checkedIds.size > 0
      ? setCheckedIds(Set())
      : setCheckedIds(Set(packages.map((p) => getPackageUID(p))));
  }
  const headerAction = (
    <Button link
      onClick={toggleAll}
      active={packages.size > 0}
      label={checkedIds.size > 0 ? "Deselect All" : "Select All"} />
  );
  const bottomAction = (
    <PackedActions
      warehouseId={warehouseId}
      packageUIds={checkedIds}
      packages={packages}
      afterClick={() => setCheckedIds(Set())}
    />
  );

  return (
    <DashboardPanel title="Ready" theme="packed" comment="Mark jobs as loaded when courier picks up."
      headerAction={headerAction}
      footer={bottomAction}>
      { ordersWithPackages }
    </DashboardPanel>
  );
}

export default withWarehousePackages(Panel);